export const SHOW_LABEL_NONE = 'None';
export const SHOW_LABEL_IMMOBILE = 'Immobile';
export const SHOW_LABEL_ALWAYS = 'All';

export const SHOW_ASSET_NONE = 'None';
